import { useState } from "react";
import { Avatar, Dropdown, Popconfirm } from "antd";
import Icon, { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import tokenService from "../../services/token.service";
import { ReactComponent as PasswordUserIcon } from "../../assets/images/SolarLockPasswordLinear.svg";
import { SETTINGS_STORAGE, SELECTED_COMPANY_STORAGE } from "helpers/consts";
import { urls } from "routes/urls";

export function ProfileDropdown({ user }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const userLogin = user.login;

    const onLogout = () => {
        setOpen(false);
        tokenService.removeToken();
        localStorage.removeItem(SETTINGS_STORAGE);
        localStorage.removeItem(SELECTED_COMPANY_STORAGE);
        window.location.href = urls.login();
    };

    const items = [
        {
            label: <Link to={urls.userEdit(userLogin)}>{t("profile")}</Link>,
            key: urls.userEdit(userLogin),
            icon: <UserOutlined />
        },
        {
            label: <Link to={urls.changePassword()}>{t("change_password")}</Link>,
            key: urls.changePassword(),
            icon: <Icon component={PasswordUserIcon} />
        },
        {
            label: (
                <Popconfirm
                    title={t("Are you sure?")}
                    okText={t("Yes")}
                    cancelText={t("No")}
                    onConfirm={onLogout}
                    onCancel={() => setOpen(false)}
                    placement='bottom'
                >
                    <a
                        href='/logout'
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }}
                    >
                        {t("logout")}
                    </a>
                </Popconfirm>
            ),
            key: "exit",
            icon: <LogoutOutlined />,
            danger: true
        }
    ];

    return (
        <Dropdown
            menu={{
                items,
                onClick: ({ key }) => {
                    if (key === "exit") return;
                    setOpen(false);
                }
            }}
            placement='bottomRight'
            trigger={["click"]}
            open={open}
            onOpenChange={setOpen}
        >
            <Avatar
                size='large'
                shape='square'
                alt={userLogin}
                icon={<UserOutlined />}
                style={{ cursor: "pointer", background: "rgba(255, 255, 255, 0.2)" }}
            />
        </Dropdown>
    );
}
